export default __webpack_public_path__ + "static/media/12.61def64b.png";